'use client';

import { defineMessages } from 'react-intl';
import CheckCircleFilled from '@alltrails/denali/icons/CheckCircleFilled';
import { useFormatMessage } from '@alltrails/core/hooks/useFormatMessage';
import styles from './CompletionBadge.module.scss';

const messages = defineMessages({
  COMPLETED: {
    defaultMessage: 'Completed'
  },
  VERIFIED: {
    defaultMessage: 'Verified completed'
  }
});

type CompletionBadgeProps = {
  variant: 'completed' | 'verified';
};

const CompletionBadge = ({ variant }: CompletionBadgeProps) => {
  const {
    formattedDefaultMessages: { COMPLETED, VERIFIED }
  } = useFormatMessage(messages);

  const displayMessage = variant === 'verified' ? VERIFIED : COMPLETED;

  return (
    <div className={styles.badge}>
      <CheckCircleFilled size="sm" />
      {displayMessage}
    </div>
  );
};

export default CompletionBadge;
